import {sLog} from "@/lib/logging/server-logging";
import {cLog} from "@/lib/logging/client-logging";

export function dynamicLog() {
    if(typeof window === "undefined") {
        return sLog();
    } else {
        return cLog();
    }
}